module.exports = __webpack_public_path__ + "images/Tvigle.ed13e5673259b4c74b645efdfa6d56de.png";